import { Pipe, PipeTransform } from '@angular/core';
import {LABELS_MAP} from '../model/labels-map';

@Pipe({
    name: 'ngcLabelFixer'
})
export class LabelFixerPipe implements PipeTransform {
    transform(columnName: string): string {
        columnName = LABELS_MAP.has(columnName) ? LABELS_MAP.get(columnName) : columnName;
        return columnName;
    }
}
